import { render } from "./MakeContract.vue?vue&type=template&id=58610646&scoped=true"
import script from "./MakeContract.vue?vue&type=script&lang=js"
export * from "./MakeContract.vue?vue&type=script&lang=js"

import "./MakeContract.vue?vue&type=style&index=0&id=58610646&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58610646"]])

export default __exports__